import { create } from 'zustand'

/**
 * Σύντομες επιβεβαιώσεις στο κάτω μέρος της οθόνης.
 *
 * Χωρίς αυτές, το «Αποθήκευση ως πρότυπο» ή το «Όλες ως διαβασμένες» δεν
 * αφήνουν ίχνος: η οθόνη δεν αλλάζει αρκετά για να καταλάβει ο χρήστης ότι
 * κάτι έγινε, και το ξαναπατάει. Το μήνυμα φεύγει μόνο του: δεν ζητά πάτημα.
 */
interface Toast {
  id: number
  tone: 'success' | 'error'
  message: string
}

interface ToastState {
  toasts: Toast[]
  push: (tone: Toast['tone'], message: string) => void
  dismiss: (id: number) => void
}

const DURATION_MS = 3200
const MAX_VISIBLE = 3
let nextId = 1

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (tone, message) => {
    const id = nextId++
    set((state) => ({ toasts: [...state.toasts, { id, tone, message }].slice(-MAX_VISIBLE) }))
    window.setTimeout(
      () => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
      DURATION_MS,
    )
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
}))

/** Καλείται και έξω από components, π.χ. μέσα σε `onSuccess` ενός mutation. */
export const toast = {
  success: (message: string) => useToastStore.getState().push('success', message),
  error: (message: string) => useToastStore.getState().push('error', message),
}
